<template>
  <div class="trustworthiness-box" v-loading="loading" element-loading-text="拼命加载中">
    <!--查询条件区域类名 -->

    <div class="queryCondition" v-if = "test == 1" >
      
      <!--form表单查询区域 -->
      <el-form :rules="rulesFrom" :model="criteria" ref="formdatas">
        <!--折叠效果区域 -->
        <!-- <el-collapse accordion value="" @change="collapseChange">
          <el-collapse-item name="1"> -->
            <!--首行展示区域 -->
            <!-- <template slot="title"> -->
              <!--阻止冒泡事件发生-此div必加，不然会点击里面的事件会触发collapseChange这个方法从而引起冒泡-->
              <div class="row" @click="stopProp" style="width:98%">
                <el-form-item label="举报人(单位)" prop="informantName">
                    <el-input v-model="criteria.informantName" clearable></el-input>
				</el-form-item>
                <el-form-item label="手机号" prop="informantPhone">
                    <el-input v-model="criteria.informantPhone" clearable></el-input>
				</el-form-item>
                <el-form-item label="验证码" prop="checkCode">
                    <template>
                      <el-input v-model="criteria.checkCode"></el-input>
                      <el-button
                        type="primary"
                        style="margin-left: 10px"
                        @click="queryphone"
                        v-if="iscode"
                        >获取验证码</el-button
                      >
              <el-button
                key="index"
                v-else
                type="primary"
                style="margin-left: 10px"
                disabled
                >{{ timer }}秒后重新获取</el-button
              >
            </template>
          </el-form-item>
              </div>
            <!-- </template> -->
            <!--第二行、第三行查询条件区域 查询重置始终保持在最后面 在展开折叠时进行切换-->
            <div class="row" @click="stopProp" style="width:98%">
            <el-form-item label="举报类别" prop="reportSubject">
					 <el-select v-model="criteria.reportSubject" placeholder="请选择" @change="cleanFormdata">
                          <el-option
                            v-for="item in reportstate"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
				</el-form-item>
        <el-form-item class="ml50">
                  <el-button
                    type="primary"
                    @click="checkType(2)"
                    icon="el-icon-search"
                    :loading="loading"
                    >切换匿名举报查询</el-button
                  >
                  <el-button
                    type="primary"
                    @click="queryListByCriteria"
                    icon="el-icon-search"
                    :loading="loading"
                    >查询</el-button
                  >
                  <el-button
                    type="info"
                    @click="resetQuery"
                    icon="el-icon-refresh"
                    :loading="loading"
                    >重置</el-button
                  >
                </el-form-item>
            </div>
          <!-- </el-collapse-item>
        </el-collapse> -->
      </el-form>
    </div>

    <div class="queryCondition" v-if="test == 2">
            <!--form表单查询区域 -->
            <el-form :rules="rulesFrom" :model="criteria" ref="formdatas">
              <div class="row" @click="stopProp" style="width:98%">
                <el-form-item label="工单号" prop="workOrderNo" style="height: 40px">
                    <el-input v-model="criteria.workOrderNo" clearable></el-input>
				</el-form-item>
                <el-form-item label="邮箱" prop="informantEmail" style="height: 40px">
                    <el-input v-model="criteria.informantEmail" clearable></el-input>
				</el-form-item>
            <!-- </template> -->
            <!--第二行、第三行查询条件区域 查询重置始终保持在最后面 在展开折叠时进行切换-->
            <el-form-item label="举报类别" prop="reportSubject" style="height: 40px">
					 <el-select v-model="criteria.reportSubject" placeholder="请选择" @change="cleanFormdata">
                          <el-option
                            v-for="item in reportstate"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
				</el-form-item>
                <el-form-item class="ml50">
                  <el-button
                    type="primary"
                    @click="checkType(1)"
                    icon="el-icon-search"
                    :loading="loading"
                    >切换实名举报查询</el-button
                  >
                  <div>
                  <el-button
                    type="primary"
                    @click="queryListByCriteria"
                    icon="el-icon-search"
                    :loading="loading"
                    >查询</el-button
                  >
                  <el-button
                    type="info"
                    @click="resetQuery"
                    icon="el-icon-refresh"
                    :loading="loading"
                    >重置</el-button
                  >
                  </div>
                </el-form-item>
            </div>
          <!-- </el-collapse-item>
        </el-collapse> -->
      </el-form>
      </div>
    <!-- table -->
    <div class="tableContent" ref="tableContent">
			<div class="ai-c mb20">
                查询结果
            </div>
			<el-table
				:data="tableData"
				ref="showTable"
				@row-click="clickRow"
				style="width: 100%"
				:height="screenHeight"
				:header-cell-style="{
					background: '#E1EEFB',
					color: '#000000',
					fontSize: '18px',
					textAlign: 'center'
				}"
				:cell-style="{
					'text-align': 'center',
					padding: '0.5rem 0',
					fontSize: '18px'
				}"
                @selection-change="handleSelectionChange"
			>
                <!-- <el-table-column type="selection"></el-table-column> -->
				<el-table-column type="index" label="序号" width="70px"></el-table-column>
				<el-table-column v-if="this.criteria.reportSubject ==  2" label="被举报单位名称" prop="unreliableUnitName" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column v-if="this.criteria.reportSubject ==  2" label="统一社会代码" prop="uscc" :show-overflow-tooltip="true"></el-table-column>

				<el-table-column v-if="this.criteria.reportSubject ==  1" label="被举报人姓名" prop="unreliableName" :show-overflow-tooltip="true"></el-table-column>
				<!-- <el-table-column v-if="columnVisible.indexOf('2') > -1" label="失信人类别" :formatter="showRequiredName" prop="isRequired" :show-overflow-tooltip="true"></el-table-column> -->
				<!-- <el-table-column v-if="columnVisible.indexOf('3') > -1" label="项目名称" :formatter="showUploadName" prop="uploadType" min-width="80" :show-overflow-tooltip="true" width="150px"></el-table-column> -->
				<!-- <el-table-column v-if="columnVisible.indexOf('4') > -1" label="承担单位" :formatter="showCorpTypeName" prop="corpType" min-width="80" :show-overflow-tooltip="true" width="150px"></el-table-column> -->
				<el-table-column v-if="this.criteria.reportSubject ==  1" label="所在单位名称" prop="unitName" min-width="80" :show-overflow-tooltip="true" width="150px"></el-table-column>
				<el-table-column label="问题类型" :formatter="showStatusName" prop="questionType" min-width="80" :show-overflow-tooltip="true"width="170px">
                    <template slot-scope="scope">
                      <span>{{ getTypeName(scope.row.questionType) }}</span>
                    </template>
                </el-table-column>
				<el-table-column label="违规主体" :formatter="showStatusName" prop="unreliableType" min-width="80" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <span>{{ getTypeName(scope.row.unreliableType) }}</span>
                    </template>
                </el-table-column>
				<el-table-column label="举报时间" :formatter="showStatusName" prop="reportTime" min-width="80" :show-overflow-tooltip="true" width="170px">
                    <template slot-scope="scope">
                        <span>{{scope.row.reportTime | dateFormat('YYYY-MM-DD HH:mm:ss')}}</span>
                    </template>
                </el-table-column>
				<el-table-column label="状态" :formatter="showStatusName" prop="virifyStatus" min-width="80" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.virifyStatus==0">暂存</span>
                        <span v-else-if="scope.row.virifyStatus==1">待受理</span>
                        <span v-else-if="scope.row.virifyStatus==2">已受理</span>
                        <span v-else-if="scope.row.virifyStatus==3">不予受理</span>
                        <span v-else-if="scope.row.virifyStatus==4">已办结</span>
                        <span v-else-if="scope.row.virifyStatus==5">中止调查</span>
                        <span v-else-if="scope.row.virifyStatus==6">已撤回</span>
                        <span v-else-if="scope.row.virifyStatus==7">已退回</span>
                    </template>
                </el-table-column>
        				<el-table-column label="提交状态" :formatter="showStatusName" prop="isSubmit" min-width="80" :show-overflow-tooltip="true"width="170px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isSubmit==0">未提交</span>
                        <span v-else-if="scope.row.isSubmit==1">已提交</span>
                  </template>
                </el-table-column>        
				<!-- <el-table-column v-if="columnVisible.indexOf('7') > -1" label="举报人" :formatter="showStatusName" prop="informantName" min-width="80" :show-overflow-tooltip="true" ></el-table-column> -->
				<!-- <el-table-column v-if="columnVisible.indexOf('8') > -1" label="举报人所在单位" :formatter="showStatusName" prop="informantUnit" min-width="80" :show-overflow-tooltip="true"  width="170px"></el-table-column> -->
				<!-- <el-table-column v-if="columnVisible.indexOf('9') > -1" label="审核状态" :formatter="showStatusName" prop="virifyStatus" min-width="80" :show-overflow-tooltip="true"></el-table-column> -->
				<el-table-column label="操作" align="left" width="190">
					<template slot-scope="scope">
						<el-button-group class="tab-button-group">
                            <el-link icon="el-icon-view" type="warning" :underline="true"  @click.native="routepush(scope.row.id)" v-if="scope.row.isSubmit==0">修改</el-link>
                            <el-link icon="el-icon-view" type="warning" :underline="true" @click="backHandler(scope.row.id)" v-if="scope.row.virifyStatus==1">撤回</el-link>
                            <el-link icon="el-icon-view" type="warning" :underline="true" @click="deleteHandler(scope.row.id)" v-if="scope.row.virifyStatus==1">撤销</el-link>
                            <el-link type="warning " icon="el-icon-edit" :underline="true" @click="updateHandle(scope.row.id)">查看</el-link>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
			<div class="row-r">
				<el-pagination
					background
					layout="total, prev, pager, next, sizes"
					:total="pageTotal"
					:current-page="pageParam.page + 1"
					:page-size="pageParam.pageSize"
					:page-sizes="[5, 10, 20, 50, 100]"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
	</div>
    <!-- 批量受理 -->
    <div class="acceptance">
        <el-dialog
          title="批量审核"
          :visible.sync="dialogVisible"
          width="40%"
          :before-close="handleClose">
          <el-form :model="addData"  ref="addData">
				<div class="row">
                    <el-form-item label="审核人" prop="name">
                    <el-input v-model="addData.name"></el-input>
				    </el-form-item>
                </div>
                <div class="row">
                    <el-form-item label="审核结果" prop="name">
                    <el-radio-group v-model="addData.finding">
                            <el-radio label="1">通过</el-radio>
                            <el-radio label="2">退回修改</el-radio>
                            <el-radio label="3">不通过</el-radio>
                    </el-radio-group>
                    </el-form-item>
                </div>
                <div class="row">
                    <el-form-item label="审核意见" prop="name">
                     <el-select v-model="formdata.tipocode" placeholder="请选择">
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                     </el-select>
                    </el-form-item>
                </div>
                <div class="row" v-if="addData.finding==1">
                    <el-form-item label="是否计入失信名单" prop="name">
                        <el-radio-group v-model="addData.name" style="width:260px">
                                <el-radio label="1">是</el-radio>
                                <el-radio label="2">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否对外公示" prop="name">
                        <el-radio-group v-model="addData.publicity" style="width:260px">
                                <el-radio label="1">是</el-radio>
                                <el-radio label="2">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
			</el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
    </div>
    <!-- 查看弹窗 -->
    <div>
        <el-dialog
        title="个人失信查看"
        :visible.sync="lookisible"
        width="50"
        :before-close="handleClose">
        <el-descriptions title="失信人信息" :column="2" border>
          <el-descriptions-item label="失信人姓名">{{detailsform.unreliableName}}</el-descriptions-item>
          <!-- <el-descriptions-item label="项目名称">{{detailsform.unreliableName}}</el-descriptions-item> -->
          <el-descriptions-item label="失信人单位名称">{{detailsform.unitName}}</el-descriptions-item>
          <!-- <el-descriptions-item label="失信人类别">{{detailsform.unreliableName}}</el-descriptions-item> -->
          <el-descriptions-item label="失信人证件号">{{detailsform.idNo}}</el-descriptions-item>
          <el-descriptions-item label="失信人手机号">{{detailsform.unreliablePhoneNumber}}</el-descriptions-item>
          <el-descriptions-item label="失信类型">{{detailsform.unreliableType}}</el-descriptions-item>
          <el-descriptions-item label="失信行为类型">{{detailsform.unreliableActType}}</el-descriptions-item>
          <el-descriptions-item :span="2" label="失信行为描述">{{detailsform.reportItem}}</el-descriptions-item>
          <el-descriptions-item :span="2" label="佐证材料">
            <a href="JavaScript:;" @click="downloadImportTemp(item.id,item.fileName)" v-for="item in detailsform.reportFiles">{{item.fileName}}</a>
          </el-descriptions-item>
          <el-descriptions-item label="举报人">{{detailsform.informantName}}</el-descriptions-item>
          <el-descriptions-item label="举报人所在单位">{{detailsform.informantUnit}}</el-descriptions-item>
          <el-descriptions-item label="举报人手机号">{{detailsform.informantPhone}}</el-descriptions-item>
          <el-descriptions-item label="举报时间">{{detailsform.reportTime}}</el-descriptions-item>
        </el-descriptions>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
        </el-dialog>
    </div>
    <!-- 受理弹窗 -->
    <div>
        <el-dialog
        title="查询结果"
        :visible.sync="dishonest"
        width="30%"
        :before-close="handleClose">
        <el-descriptions title="" border :column="1">
          <el-descriptions-item label="被举报单位名称" v-if="this.criteria.reportSubject ==  2" >{{examineform.unreliableUnitName}}</el-descriptions-item>
          <el-descriptions-item label="统一社会代码" v-if="this.criteria.reportSubject ==  2" >{{examineform.uscc}}</el-descriptions-item>
          <el-descriptions-item label="被举报人姓名" v-if="this.criteria.reportSubject ==  1" >{{examineform.unreliableName}}</el-descriptions-item>
          <el-descriptions-item label="所在单位名称" v-if="this.criteria.reportSubject ==  1" >{{examineform.unitName}}</el-descriptions-item>
          <el-descriptions-item label="问题类型">
            <span>{{ getTypeName(examineform.questionType) }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="违规主体">
            <span>{{ getTypeName(examineform.unreliableType) }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="违规行为">
            <span>{{ getTypeName(examineform.unreliableActType) }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="举报时间">{{examineform.reportTime | dateFormat('YYYY-MM-DD HH:mm:ss')}}</el-descriptions-item>
          <el-descriptions-item label="状态">
              <span v-if="examineform.virifyStatus==0">暂存</span>
                <span v-else-if="examineform.virifyStatus==1">待受理</span>
                <span v-else-if="examineform.virifyStatus==2">已受理</span>
                <span v-else-if="examineform.virifyStatus==3">不予受理</span>
                <span v-else-if="examineform.virifyStatus==4">已办结</span>
                <span v-else-if="examineform.virifyStatus==5">中止调查</span>
                <span v-else-if="examineform.virifyStatus==6">已撤回</span>
          </el-descriptions-item>
        </el-descriptions>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dishonest = false">取 消</el-button>
          <el-button type="primary" @click="dishonest = false">确 定</el-button>
        </span>
        </el-dialog>
    </div>
  </div>
</template>

<script>
import personService from "../../../api/tabulation/tabulation"
import {dateFormat} from "../../../utils/formatTime"
export default {
  data() {
    return {
      test :1,
        loading:false,
      headers: {"Content-Type": "multipart/form-data;charset=UTF-8"},//上传的请求头
      isshowbutton:false,//查询、重置按钮显示标志位
      screenHeight: null, //table高度
      dialogVisible:false, //新增弹窗
      lookisible:false,//查看弹窗
      formdata:{}, //查询
      dishonest:false,//失信受理
      dishonestform:{},//失信受理信息
      handle:false,//失信办理
      handleform:{},//失信办理信息
      options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
      tableData:[],
      pageParam: {
		  page: 1,
		  pageSize: 10,
		},
        // 页码数
      pageTotal:0,
    //   列表项设置
    //   columnVisible:"",
      columnVisible: ['1', '2', '3','4','5','6','7','8','9'],
      columnLabel: [
			{
				value: '1',
				lable: '失信人姓名'
			},
			{
				value: '2',
				lable: '失信类型'
			},
			{
				value: '3',
				lable: '失信人单位名称'
			},
			{
				value: '4',
				lable: '举报行为类型'
			},
            {
				value: '5',
				lable: '是否计入失信名单'
			},
			{
				value: '7',
				lable: '是否对外公示'
			},
			{
				value: '7',
				lable: '举报人'
			},
            {
				value: '8',
				lable: '举报人所在单位'
			},
            {
				value: '9',
				lable: '审核状态'
			},
	  ],
      //新增信息
      addData:{
        ww:""
      },
    selectList: [],  // 选中的数据
    detailsform:{}, //详情数据
    examineform:{},//流程图
    //失信类型
    types: [],
    //举报类型
    reportType:[
        {
          value: '1',
          label: '实名'
        }, 
        {
          value: '2',
          label: '匿名'
        },
    ],
    // 状态
    reportstate:[
        {
          value: '1',
          label: '个人'
        }, 
        {
          value: '2',
          label: '单位'
        },
    ],
    // 是否记入失信人名单
    record:[
        {
          value: 'Y',
          label: '是'
        }, 
        {
          value: 'N',
          label: '否'
        },
    ],
    foreign:[
        {
          value: 'Y',
          label: '是'
        }, 
        {
          value: 'N',
          label: '否'
        },
    ],
        //   查询条件
    criteria:{
        page:1,
        pageSize:10,
        informantPhone:'',
        reportSubject:'1',
        reportType: 1
    },
    iscode:true,
    timer:60,
      //非空验证
      rulesFrom: {
        informantName: [{ required: true, message: "请输入举报人姓名", trigger: "blur" },],
        informantPhone: [{ required: true, message: "请输入手机号", trigger: "blur" },],
        checkCode: [{ required: true, message: "请输入验证码", trigger: "blur" },],
        reportSubject: [{ required: true, message: "请选择举报类别", trigger: "blur" },],
        workOrderNo: [{ required: true, message: "请输入工单号", trigger: "blur" },],
        informantEmail: [{ required: true, message: "请输入邮箱", trigger: "blur" },],
      },
    };
  },
  mounted() {
    this.getTypes()
    this.tableheight()
  },

  methods: {
    getTypes () {
      personService.getType('').then((res) => {
          this.types = res.data;
      }).catch(error => {
        this.$message({message: error, type: 'warning'});
      })
    },
    getTypeName (typeCodes) {
      let typeName = []
      if (typeCodes) {
        typeCodes = typeCodes.split(",")
        this.types.forEach(item => {
          if (typeCodes.includes(item.typeCode)) {
            typeName.push(item.typeValue)
          }
        })
      }
      return typeName.join('；')
    },
    // 阻止冒泡
    stopProp(e) {
      e.stopPropagation();
    },
    // 给表格定义高度
    tableheight() {
        if(this.tableData.length <= 0){
            this.screenHeight = 100
        } else{
            const he = window.innerHeight
            const h = this.$refs.tableContent.getBoundingClientRect().top + 157;
            this.screenHeight = he - h ;
        }

    },
    checkType(type){
      this.$refs['formdatas'].clearValidate()
      this.test = type
      this.resetQuery()
    },
    //折叠效果-控制表格
    collapseChange(e) {
        console.log(e);
      if (e == 1) {
        this.isshowbutton = !this.isshowbutton;
        setTimeout(() => {
            this.tableheight();
        }, 300);
      } else {
        this.isshowbutton = !this.isshowbutton;
        setTimeout(() => {
            this.tableheight();
        }, 300);
      }
    },
    cleanFormdata(){
      this.tableData=[]
      this.$refs['formdatas'].clearValidate('reportSubject')
    },
    // 查询
    queryListByCriteria(){
        
        this.$refs.formdatas.validate(valid => {
        // 点确定新增校验哪些值没传
        if(valid){
            this.loading = true
                personService.querydishonesty(this.criteria).then(res=>{
                if (res.code !== '200') {
                  this.$message({
                    message: res.message,
                    type: 'warning'
                  });
                  this.loading = false
                  return;
                }
                this.tableData = res.data.list
                this.pageTotal= res.data.total
                //获取表格的高度
                this.tableheight();
                this.loading = false
            }).catch(res=>{
                this.loading = false
                this.$message({
                message:res.response.data.message ,
                type: 'warning'
                });
            })
        }
    })
    },
    // 重置
    resetQuery(){
      this.criteria = {
        page: 1,
        pageSize: 10,
        reportSubject:'1',
        informantPhone:'',
        reportType: this.test
      }
      this.tableData = []
    },
    // excel批量筛选
    addHandle(){
        this.dialogVisible= true
    },
    // 批量导入
    // batchImport(){

    // },
    handleExcel(file) {
      let formData = new FormData(); //声明一个FormDate对象
      formData.append("formFile", file.raw);    //把文件信息放入对象中
      console.log(file.raw,"文件");
      //调用后台导入的接口
      SetPDFile(formData).then(res => {
        // console.log(res)
        if (res.Status && res.Data) {
          this.$message.success("导入成功");
          this.getList();   // 导入表格之后可以获取导入的数据渲染到页面，此处的方法是获取导入的数据
        } else {
          this.$message.error(res.Message)
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: '导入失败'
        })
      })
    },
    //审核弹窗
    updateHandle (id) {
      personService.querychart(id).then(res => {
        this.dishonest = true
        this.examineform = res.data
      })
    },
    // 撤回按钮
    backHandler(id){
        personService.withdraw(id).then(res=>{
        })
        this.routepush(id)
    },
    //  
    updateHandler(id){
      personService.querychart(id).then(res=>{
              this.dishonest = false
              this.examineform = res.data
              
        })
    },
    routepush(id){
      personService.querychart(id).then(res=>{
        this.examineform = res.data
        // 复选框处理
        this.examineform.questionTypes = res.data.questionType ? res.data.questionType.split(',') : []
      if (this.examineform.reportType == 1 && this.examineform.reportSubject == 1){
         this.$router.push({
          path : "/research-integrity/realname",
          query : {
            id : 1,
            updateFormdata : this.examineform
          }
         })


    } else if(this.examineform.reportType == 2 && this.examineform.reportSubject == 1){
      this.$router.push({
          path : "/research-integrity/anonymous",
          query : {
            id : 1,
            updateFormdata : this.examineform
          }
         })
    }else if(this.examineform.reportType == 1 && this.examineform.reportSubject == 2){
      this.$router.push({
          path : "/research-integrity/realname",
          query : {
            id : 2,
            updateFormdata : this.examineform
          }
         })
    }else {
      this.$router.push({
          path : "/research-integrity/anonymous",
          query : {
            id : 2,
            updateFormdata : this.examineform
          }
         })
    }
    })
    },
        // 撤销按钮
        deleteHandler(id){
        personService.delete(id).then(res=>{
            personService.querydishonesty(this.criteria).then(res=>{
            this.tableData = res.data.list
            this.pageTotal= res.data.total
            //获取表格的高度
            this.tableheight(0);
            this.$message({
            message: '撤销成功',
            type: 'success'
        });
        })
        })
    },
    //页码变化
	handleCurrentChange(currentPage) {
		this.pageParam.page = currentPage - 1;
		// this.queryList();
	},
    //选中某条数据时
    handleSelectionChange(row) {
      this.selectList = row;     // 将选中的数据给selectList
        console.log(this.selectList,"将选中的数据给selectList")
    },
    //导出
    // handleExport() {
    //   if (this.selectList.length === 0) {
    //     this.$message({
    //       message: '请至少选择一条需要导出的数据',
    //       type: 'warning'
    //     });
    //     return;
    //   }
    //   this.$confirm('该操作将导出选中的数据，是否继续', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     //导出
    //     require.ensure([], () => {
    //       const { export_json_to_excel } = require('@/excel/Export2Excel');   //注意这个Export2Excel路径
    //       const tableHeader = ['失信人姓名','失信类型', '失信人单位名称', '失信行为类型', '是否记入失信名单','是否对外公示', '举报人', '举报人所在单位', '审核状态'];   // 设置Excel表格的表头
    //       const filterVal = ['informantName	', 'reportType', 'unitName', 'unreliableActType', 'isUnreliable', 'isPublicity', 'informantName', 'informantUnit', 'virifyStatus'];  // 跟表格表头对应的绑定的prop
    //       let list = this.filterTableData(JSON.parse(JSON.stringify(this.selectList)));   // this.selectList为选中的要导出的数据，用filterTableData方法先处理一下数据格式(要进行深度拷贝，以免过滤的时候，影响页面上展示的数据)，再存到list
    //       let data = this.formatJson(filterVal, list);
    //       export_json_to_excel(tableHeader, data, '查询统计');    //最后一个是导出表格的名字
    //     })
    //   }).catch(() => { });
    // },
    formatJson(filterVal, Data) {
      return Data.map(v => filterVal.map(j => v[j]))
    },
    //导出数据前对数据处理
    filterTableData(data) {
      data.forEach(item => {
        // item.applyDate = shortTime(item.applyDate)   // 将导出的时间转换成'YYYY-MM-DD'格式
        item.workAge = item.workAge + '年'
      })
      return data;
    },
    //初始化分页查询
    Initialize(){
        personService.querydishonesty(this.pageParam).then(res=>{
            this.tableData = res.data.list
            this.pageTotal= res.data.total
            //获取表格的高度
            this.tableheight(0);
        })
    },
    // 下载文件
    downloadImportTemp(id,name) {
       personService.addfiles(id).then(res=>{
       let blob = new Blob([res], {type: "application/pdf" })
       let url = window.URL.createObjectURL(blob)
       let link = document.createElement('a')
       link.style.display = 'none'
       link.download =  name
       link.href = url
       link.click()
       link.remove()
      })
    },
    // 发送验证码
    queryphone() {
      if (this.criteria.informantPhone.length != 11 || this.criteria.informantPhone ==  '' ) {
        this.$message({
          message: "请输入正确手机号",
          type: "warning",
        });
      } else {
        personService.queryphone(this.criteria.informantPhone).then((res) => {
          let timer = 60;
          this.iscode = false;
          this.timeFun = setInterval(() => {
            --timer;
            this.timer = timer;
            if (timer == 0) {
              clearInterval(this.timeFun);
              this.iscode = true;
            }
          }, 1000);
        }).catch(err =>{
            console.log(err);
            this.$message({
             message: err.response.data.message,
            type: "warning",
            });
        })
      }
    },
    clickRow(){
        console.log("clickRow");
    },
    showStatusName(){
        console.log("showStatusName");
    },
    handleSizeChange(){
        console.log("handleSizeChange");
    },
    handleClose(){
        this.dishonest = false;
        console.log("handleClose");
    }
  },
  filters: {
    dateFormat
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-collapse-item__header {
	display: flex;
	height: 78px;
	flex-wrap: wrap;
	line-height: 32px;
}
.el-collapse {
	border: 0;
}
::v-deep .el-collapse-item__arrow {
	margin: 0;
	margin-top: -23px;
} 
::v-deep .queryCondition .el-form-item__label{
    width: 120px !important;
}
.trustworthiness-box {
    width: 1280px;
    margin: 0 auto;
}
::v-deep .el-select > .el-input{
    width: 190px;
}
::v-deep .el-input{
    width: 190px;
}
::v-deep .el-collapse-item__header{
    position: relative;
}
::v-deep .el-collapse-item__arrow{
    right: 30px;
}
::v-deep .el-table__empty-block {
  min-height: 20px;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>